// The persistent stat row above the tab bar.
//
// Built to Figma 7101:6470 and siblings: label + info glyph on top, then the
// value and its caption on ONE baseline ("43  the full sample"), with the two
// thin brand arcs sweeping through the right edge. Each card says what the
// number is a share OF, because a bare count with no base is the easiest
// number on a dashboard to misread.
//
// Truncation rule (user 2026-08-24): label, value and caption each show their
// full text on hover ONLY when they are actually cut - ClampText measures the
// element, so text that fits shows no tooltip at all.
import React from "react";
import { Tooltip } from "antd";
import { StatRow, StatCard } from "./primitives";
import { CountUp, ClampText } from "./motion";
import { stripDashes } from "./text";
import icInfo from "../assets/summary/ic_info.svg";

// "68%" / "625" / "1,204" count up (user 2026-08-21: "counter affect");
// anything else renders as text.
const numericValue = (v) => {
  if (typeof v === "number") return { n: v, suffix: "" };
  if (typeof v === "string") {
    const m = v.trim().match(/^([\d,]+)(%?)$/);
    if (m) return { n: parseInt(m[1].replace(/,/g, ""), 10), suffix: m[2] };
  }
  return null;
};

/**
 * @param {Array<{label,value,sub,hint,valueColor,labelTitle}>} cards
 */
export default function StatCards({ cards = [] }) {
  const shown = cards.filter(Boolean);
  if (!shown.length) return null;
  return (
    <StatRow $n={Math.min(shown.length, 4)}>
      {shown.map((c) => {
        const num = numericValue(c.value);
        return (
          <StatCard
            key={c.label}
            $valueColor={c.valueColor}
            className={num ? undefined : "is-text"}
          >
            <div className="stat-label">
              <ClampText className="stat-label-text" text={stripDashes(c.label)} />
              {c.hint && (
                <Tooltip title={c.hint} placement="top">
                  <img className="stat-info" src={icInfo} alt="" />
                </Tooltip>
              )}
            </div>
            <div className="stat-body">
              {num ? (
                <span className="stat-value">
                  <CountUp value={num.n} suffix={num.suffix} />
                </span>
              ) : (
                <ClampText className="stat-value" text={stripDashes(c.value)} />
              )}
              {c.sub && <ClampText className="stat-sub" text={stripDashes(c.sub)} />}
            </div>
          </StatCard>
        );
      })}
    </StatRow>
  );
}
